export enum MediaCategory {
    DocumentatyFilm = "Documentary Film",
    MobileFilmMaker = "Mobile Film-Maker",
    SpiritualSongVideoClip = "Spiritual Song Video Clip"
    
}

export enum MediaEmailType {
    performanceAwaitingApproval = 0,
    performanceApproved = 1,
    performancePaymentAdded = 2,
    performancePaymentConfirmed = 3,
    performanceFileUploaded = 4,
    performanceSubmissionCompleted = 5,
    performanceReviewSubmitted = 6
}

export enum MediaStatus {
    ProjectReviewRequired = 'Lyrics Review Required',
    SubmissionFailed = 'Submission Failed',

    // Cannot submit without uploaded file / url
    PendingCoordinatorApproval = 'Pending Coordinator Approval',
    PendingPayment = 'Pending Payment',
    PendingProject = 'Pending Project',
    PendingReview = 'Pending Review',
    SubmissionCompleted = 'Submission Completed'
}
